import { Injectable } from '@angular/core';
import { GpkgAutoStyleHandler, GpkgAutoStyleType } from '@luzula/luzula-lib';

/**
 * Handler für die automatische Erkennung von Bohrpunkte-Styles in GeoPackage-Dateien.
 * Erkennt standort, humusform und haken Layer anhand ihrer Attributnamen.
 */
@Injectable({ providedIn: 'root' })
export class BohrpunktGpkgAutoStyleHandler implements GpkgAutoStyleHandler {
	/**
	 * Erkennt den Autostyle-Typ anhand der Attributnamen.
	 * - standort: LBFO1 oder STGR1
	 * - humusform: HUFO1
	 * - haken: SYMBOL + ART + ANGLE
	 */
	detectAutoStyle(attributeNames: string[]): GpkgAutoStyleType {
		const keys = attributeNames.map(k => k.toUpperCase());

		if (keys.includes('LBFO1') || keys.includes('STGR1')) {
			return 'standort';
		}
		if (keys.includes('HUFO1')) {
			return 'humusform';
		}
		// Haken-Layer: SYMBOL, ART, ANGLE
		if (keys.includes('SYMBOL') && keys.includes('ART') && keys.includes('ANGLE')) {
			return 'haken';
		}

		return null;
	}
}
